import { useEffect } from "react";
import { appStore } from "src/stores/app.store.ts";

export const useTrackPointerType = () => {
  useEffect(() => {
    const handlePointerDown = (event: PointerEvent) => {
      appStore.setPointerType(event.pointerType);
    };

    document.addEventListener("pointerdown", handlePointerDown, true);

    return () => {
      document.removeEventListener("pointerdown", handlePointerDown, true);
    };
  }, []);
};
